var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThirdStage = function SvgThirdStage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.707 24.233a2.383 2.383 0 0 0 .096 3.392 2.4 2.4 0 1 0 0-3.392zm-.277-1a3.4 3.4 0 1 1-.322 5.111 3.384 3.384 0 0 1-.123-4.802l.295-.309zm-1.847-1.125L18.306 6.417l.001-.001a2.407 2.407 0 0 1 3.39.001l4.218 4.218.001.001a2.41 2.41 0 0 1 0 3.389h-.001L10.224 29.75a5.403 5.403 0 0 1-7.641-7.64m8.348 8.348a6.403 6.403 0 1 1-9.056-9.055L17.602 5.707a3.41 3.41 0 0 1 4.8 0l4.223 4.224a3.41 3.41 0 0 1 0 4.8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.592 32.328A3.41 3.41 0 0 0 32 28.921v-5.984a3.41 3.41 0 0 0-3.408-3.408h-6.735L10.93 30.457a6.4 6.4 0 0 1-4.517 1.872zm-17.125-1h17.125A2.41 2.41 0 0 0 31 28.921v-5.984a2.41 2.41 0 0 0-2.408-2.408h-6.32L11.636 31.164z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.004 3.74v22.19a5.4 5.4 0 0 0 10.799 0V3.74a2.407 2.407 0 0 0-2.408-2.408H3.412A2.41 2.41 0 0 0 1.004 3.74m2 22.193A3.416 3.416 0 1 1 6.4 29.329h-.003l.006-1v1H6.4a3.4 3.4 0 0 1-3.396-3.396m1-.004h-1v.007zm-4 0V3.74A3.41 3.41 0 0 1 3.412.333h5.983a3.41 3.41 0 0 1 3.408 3.408v22.19a6.4 6.4 0 1 1-12.799 0",
    clipRule: "evenodd"
  })));
};
export default SvgThirdStage;